export default __webpack_public_path__ + "static/media/Resume.04527472.pdf";